// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"pL-z","carouselContainer":"qL-z"};